module.exports = __webpack_public_path__ + "static/media/shakti_logo.eea76cdc.png";